import Request from './request';

async function tree(data) {
    return Request('get', "api/food-categories/tree", data);
}

async function save(id,data){// 编辑或新建数据（有id为编辑，没有id为新建）
    if(id){
        return Request('post', "api/food-categories/edit?id=" + id, data);
    } else {
        return Request('post', "api/food-categories/add" , data);
    }
}

async function del(id){// 删除数据
    return Request('get', "api/food-categories/delete/", id ? { id: id} : {});
}

export default {
    tree,
    save,
    del,
};